export const urlAPI =
  window.location.origin === "http://daftaronline.petrograhamedika.com"
    ? "http://139.255.11.202:8080/pgm_backend"
    : window.location.origin === "http://www.daftaronline.petrograhamedika.com"
    ? "http://139.255.11.202:8080/pgm_backend"
    : window.location.origin === "http://daftaronline.rspg-group.com"
    ? "http://139.255.11.202:8080/pgm_backend"
    : window.location.origin === "http://www.daftaronline.rspg-group.com"
    ? "http://139.255.11.202:8080/pgm_backend"
    : window.location.origin === "http://192.168.10.4:1122"
    ? "http://192.168.10.4:80/pgm_backend"
    : window.location.origin === "http://192.168.10.226:3003"
    ? "http://192.168.10.226:8080/pgm_backend"
    : window.location.origin === "http://192.168.10.226:3000"
    ? "http://192.168.10.226:8080/pgm_backend":
      window.location.origin === "http://10.100.1.63:3000"
    ? "http://10.100.1.63:8080/pgm_backend"
    : window.location.origin === "http://139.255.11.202:1122"
    ? "http://139.255.11.202:8080/pgm_backend"
    : window.location.origin === "http://localhost:3003"
    ? "http://localhost:8080/pgm_backend"
    : window.location.origin === "http://localhost:3000"
    ? "http://localhost:8080/pgm_backend"
    //     :  window.location.origin === "http://localhost:3001"
    //     ? process.env.REACT_APP_CONFIG_URL_API_LOCALDEV
    //  : "http://localhost:8080/pgm_backend"    
    : window.location.origin === "http://192.168.10.176:3001"
    ? "http://192.168.10.176/pgm_backend"
    : "http://localhost:8080/pgm_backend";

//export const urlAPI = "http://localhost:80/pgm_backend";
//export const yanTes = "123TTTTT";
//console.log("urlAPI 1111", urlAPI);
//console.log("yan",yanTes);
export const multiPartSetting = {
  "Content-Type": `multipart/form-data;`,
};

export function fillObj(parent, obj) {
  for (let key of Object.keys(parent)) {
    if (obj[key]) {
      parent[key] = obj[key];
    }
  }
  return parent;
}

export function sumAllData(arrayOfObject, key = "") {
  return arrayOfObject.reduce((a, b) => a + (b[key] || 0), 0);
}

// return the user data from the session storage
export const getUser = () => {
  const userStr = localStorage.getItem("user");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

// return the token from the session storage
export const getToken = () => {
  return localStorage.getItem("token") || null;
};

// remove the token and user from the session storage
export const removeUserSession = () => {
  localStorage.clear();
};

// set the token and user from the session storage
export const setUserSession = (token, user, expiredAt) => {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("expired", expiredAt);
};

export function toFloatDecimal(number = "0") {
  let numberString = String(number);
  return parseFloat(numberString.replace(/\./g, "").replace(",", "."));
}

export function toNumber(number = "0") {
  return Number(number.toString().replace(/\./g, "").replace(",", "."));
}
